import React from "react";
import Slider from "react-slick";
import OfferCard from './OfferCard';
import { ChevronLeft, ChevronRight } from "lucide-react";
import offer1 from '../assets/images/offer1.webp';
import offer2 from '../assets/images/offer2.webp';
import offer3 from '../assets/images/offer3.webp';
import offer4 from '../assets/images/offer4.webp';

const SampleNextArrow = ({ className, style, onClick }) => (
  <div className={className} style={{ ...style }} onClick={onClick}>
    <ChevronRight className="home-offer-card-arrow" size={12} />
  </div>
);

const SamplePrevArrow = ({ className, style, onClick }) => (
  <div className={className} style={{ ...style }} onClick={onClick}>
    <ChevronLeft className="home-offer-card-arrow" size={12} />
  </div>
);

function HomeOfferCarousel() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          centerMode: false, // ✅ Yaha change kiya
          autoplay: true,
          autoplaySpeed: 2500
        },
      },
    ],
  };

  return (
    <div className="home-offer-card-slider-wrapper">
      <Slider {...settings}>
        <OfferCard imageSrc={offer1} backgroundColorClass="home-offer-card-bg-blue" />
        <OfferCard imageSrc={offer2} backgroundColorClass="home-offer-card-bg-green" />
        <OfferCard imageSrc={offer3} backgroundColorClass="home-offer-card-bg-pink" />
        <OfferCard imageSrc={offer4} backgroundColorClass="home-offer-card-bg-orange-light" />
      </Slider>
    </div>
  );
}

export default HomeOfferCarousel;
